module.exports = __webpack_public_path__ + "img/tip.d1f2cffa.svg";